import { useAuthStore } from "../store/auth.store";

export const getFirstAllowedRoute = (permissions) => {
  // Organizers always land on events
  const user = useAuthStore.getState().user;
  if (user?.user_category === "organizer") return "/events";

  if (permissions.users) return "/users";
  if (permissions.promoters) return "/promoters";
  if (permissions.user_types) return "/user-types";
  if (permissions.events) return "/events";
  if (permissions.bookings) return "/bookings";
  if (permissions.artists) return "/artists";
  if (permissions.documents) return "/documents";
  if (permissions.emails) return "/emails";
  if (permissions.financial) return "/financial";

  return "/no-access";
};